import ClientVersionSelect from './client-version-select';

export default ClientVersionSelect;
